import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddSchedulesDynamic from "../schedules/AddSchedulesDynamic";

const AddSchedulesDynamicDialog = ({ open, onClose, scheduleName }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddSchedulesDynamic scheduleName={scheduleName} />
      </Box>
    </Dialog>
  );
};

export default AddSchedulesDynamicDialog;
